var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-cells',[_c('h1',{staticClass:"title"},[_vm._v("List of cash requests for orders")])]),(_vm.is_product_storage_manager || _vm.is_product_storage_supervisor)?_c('app-tabs',{attrs:{"tabs":_vm.tabs}}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }